import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from './AuthContext'

export default function LoginSAML() {
    const navigate = useNavigate()
    const { isTokenExpired } = useAuth()

    const parseStoredToken = (storedToken) => {
        if (!storedToken) return null
        try {
            const parsed = JSON.parse(storedToken)
            return typeof parsed === 'string' ? parsed : null
        } catch {
            return typeof storedToken === 'string' ? storedToken : null
        }
    }

    useEffect(() => {
        const storedToken = localStorage.getItem('token')
        const tokenPersistido = parseStoredToken(storedToken)

        if (tokenPersistido) {
            try {
                if (!isTokenExpired(tokenPersistido)) {
                    navigate('/home', { replace: true })
                    return
                }
            } catch {
                // Si el token almacenado es inválido lo descartamos y seguimos a login SAML.
            }

            localStorage.removeItem('token')
        }

        const backendURL = process.env.REACT_APP_BACK_API_EVALUACION;
        const nextUrl = process.env.REACT_APP_BACK_API_EVALUACION_NEXT_URL;
        window.location.href = `${backendURL}/admin/login/?next=${encodeURIComponent(nextUrl)}`;
    }, [isTokenExpired, navigate])

};